import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Check, Clock3, CreditCard, ShieldCheck, Smartphone } from 'lucide-react'
import { Link } from 'react-router-dom'
import { api, getApiErrorMessage } from '../lib/api'
import {
  cancelMyPortOneRecurringAgreement,
  confirmPortOneV2RedirectPayment,
  confirmPortOneV2RecurringRedirect,
  getMyPortOneRecurringAgreement,
  getPortOneV2CheckoutConfig,
  isPortOneV2RecurringRedirect,
  requestPortOneV2RecurringSubscription,
  requestPortOneV2SubscriptionPayment,
} from '../lib/portoneCheckout'
import { queryClient } from '../lib/queryClient'

const COPY = {
  eyebrow: '\uAC1C\uC778 \uAD6C\uB3C5',
  title: '\uAD6C\uB3C5\uD558\uAE30',
  back: '\uB0B4 \uAD6C\uB3C5\uC73C\uB85C \uB3CC\uC544\uAC00\uAE30',
  loading: '\uACB0\uC81C \uC815\uBCF4\uB97C \uBD88\uB7EC\uC624\uB294 \uC911\uC785\uB2C8\uB2E4.',
  mobileTitle: '\uD604\uC7AC \uC571\uC5D0\uC11C\uB9CC \uACB0\uC81C\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4',
  mobileBody: '\uC124\uACC4EZ \uBAA8\uBC14\uC77C \uC571\uC758 \uB0B4 \uC815\uBCF4 > \uAD6C\uB3C5 \uAD00\uB9AC\uC5D0\uC11C \uACB0\uC81C\uD574 \uC8FC\uC138\uC694.',
  webTitle: '\uC6F9 \uCE74\uB4DC \uACB0\uC81C',
  oneTimeDescription: '\uACB0\uC81C \uC644\uB8CC\uC77C\uBD80\uD130 1\uAC1C\uC6D4\uAC04 \uC774\uC6A9\uD560 \uC218 \uC788\uC73C\uBA70, \uC790\uB3D9 \uAC31\uC2E0\uB418\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.',
  recurringDescription: '\uCCAB \uACB0\uC81C \uD6C4 \uB9E4\uC6D4 \uB9CC\uB8CC\uC77C\uC5D0 \uB3D9\uC77C\uD55C \uCE74\uB4DC\uB85C \uC790\uB3D9 \uAC31\uC2E0\uB429\uB2C8\uB2E4.',
  recurring: '\uC6D4 \uC790\uB3D9 \uAC31\uC2E0',
  oneTime: '1\uAC1C\uC6D4 \uB2E8\uAC74',
  cancelRecurring: '\uC790\uB3D9 \uACB0\uC81C \uD574\uC9C0',
  cancelConfirm: '\uB2E4\uC74C \uC790\uB3D9 \uACB0\uC81C\uC744 \uD574\uC9C0\uD560\uAE4C\uC694? \uC774\uBBF8 \uACB0\uC81C\uD55C \uC774\uC6A9\uAE30\uAC04\uC740 \uB9CC\uB8CC\uC77C\uAE4C\uC9C0 \uC720\uC9C0\uB429\uB2C8\uB2E4.',
  consentPrefix: '\uACB0\uC81C \uC804 ',
  terms: '\uC774\uC6A9\uC57D\uAD00',
  and: '\uACFC ',
  refund: '\uD658\uBD88\u00B7\uCDE8\uC18C \uC815\uCC45',
  consentSuffix: '\uC744 \uD655\uC778\uD588\uC73C\uBA70 \uB3D9\uC758\uD569\uB2C8\uB2E4.',
  recurringConsent: '\uC790\uB3D9 \uAC31\uC2E0 \uC120\uD0DD \uC2DC \uD574\uC9C0 \uC804\uAE4C\uC9C0 \uB9E4\uC6D4 \uB3D9\uC77C\uD55C \uC694\uAE08\uC774 \uACB0\uC81C\uB418\uB294 \uAC83\uC5D0 \uB3D9\uC758\uD569\uB2C8\uB2E4.',
  consentRequired: '\uC774\uC6A9\uC57D\uAD00\uACFC \uD658\uBD88\u00B7\uCDE8\uC18C \uC815\uCC45\uC5D0 \uB3D9\uC758\uD574 \uC8FC\uC138\uC694.',
  paymentFailed: '\uACB0\uC81C\uB97C \uC644\uB8CC\uD558\uC9C0 \uBABB\uD588\uC2B5\uB2C8\uB2E4.',
  paymentSuccess: '\uACB0\uC81C\uAC00 \uC644\uB8CC\uB418\uC5B4 \uAD6C\uB3C5\uC774 \uBC14\uB85C \uBC18\uC601\uB410\uC2B5\uB2C8\uB2E4.',
  redirected: '\uACB0\uC81C\uCC3D\uC5D0\uC11C \uACB0\uC81C\uB97C \uC644\uB8CC\uD574 \uC8FC\uC138\uC694.',
  processing: '\uCC98\uB9AC \uC911',
  recurringActive: '\uC790\uB3D9 \uAC31\uC2E0 \uC774\uC6A9 \uC911',
  pay: '\uACB0\uC81C\uD558\uAE30',
  startRecurring: '\uC790\uB3D9 \uAC31\uC2E0 \uC2DC\uC791',
  secure: '\uD3EC\uD2B8\uC6D0 V2\uB97C \uD1B5\uD574 \uC548\uC804\uD558\uAC8C \uACB0\uC81C\uB429\uB2C8\uB2E4.',
}

const FALLBACK_PLANS = [
  { planCode: 'BASIC', planName: 'BASIC', price: 9900, currency: 'KRW', periodMonths: 1 },
  { planCode: 'ENTERPRISE', planName: 'ENTERPRISE', price: 29900, currency: 'KRW', periodMonths: 1 },
]

const PLAN_FEATURES = {
  BASIC: [
    '\uC9C4\uB8CC\uC815\uBCF4\uBD84\uC11D\u00B7\uC228\uC740\uBCF4\uD5D8\uAE08\u00B7\uD1B5\uD569\uB9AC\uD3EC\uD2B8 \uAC01 5\uD68C',
    '\uBCF4\uD5D8\uAE08\uCCAD\uAD6C 2\uAC74, \uCD5C\uB300 30\uC7A5',
    '\uC0AC\uC9C4 \uBC30\uACBD \uC81C\uAC70 3\uD68C',
  ],
  ENTERPRISE: [
    '\uC9C4\uB8CC\uC815\uBCF4\uBD84\uC11D\u00B7\uC228\uC740\uBCF4\uD5D8\uAE08\u00B7\uD1B5\uD569\uB9AC\uD3EC\uD2B8 \uAC01 50\uD68C',
    '\uBCF4\uD5D8\uAE08\uCCAD\uAD6C 30\uAC74, \uCD5C\uB300 300\uC7A5',
    '\uC0AC\uC9C4 \uBC30\uACBD \uC81C\uAC70 10\uD68C',
  ],
}

function responseData(response) {
  return response?.data?.data ?? response?.data ?? null
}

function formatPrice(value) {
  return new Intl.NumberFormat('ko-KR').format(Number(value || 0))
}

function formatDate(value) {
  if (!value) return '-'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return '-'
  return new Intl.DateTimeFormat('ko-KR', {
    year: 'numeric', month: '2-digit', day: '2-digit',
  }).format(date)
}

function clearPaymentQuery() {
  if (typeof window === 'undefined') return
  const url = new URL(window.location.href)
  ;['paymentId', 'transactionType', 'txId', 'billingKey', 'issueId', 'code', 'message'].forEach((key) => {
    url.searchParams.delete(key)
  })
  window.history.replaceState({}, '', url.pathname + url.search + url.hash)
}

export default function BillingSubscribePage() {
  const [checkoutConfig, setCheckoutConfig] = useState(null)
  const [plans, setPlans] = useState(FALLBACK_PLANS)
  const [loading, setLoading] = useState(true)
  const [agreed, setAgreed] = useState(false)
  const [processingPlan, setProcessingPlan] = useState(null)
  const [message, setMessage] = useState(null)
  const [error, setError] = useState(null)
  const [paymentMode, setPaymentMode] = useState('ONE_TIME')
  const [recurringState, setRecurringState] = useState(null)
  const [canceling, setCanceling] = useState(false)

  const visiblePlans = useMemo(() => {
    const byCode = new Map(FALLBACK_PLANS.map((plan) => [plan.planCode, plan]))
    plans.forEach((plan) => {
      const code = String(plan?.planCode || '').toUpperCase()
      if (byCode.has(code)) byCode.set(code, { ...byCode.get(code), ...plan, planCode: code })
    })
    return ['BASIC', 'ENTERPRISE'].map((code) => byCode.get(code))
  }, [plans])

  const managedRecurring = recurringState?.agreement && ![
    'CANCELED', 'INITIAL_FAILED', 'PAYMENT_FAILED',
  ].includes(recurringState.agreement.status)

  const refreshBillingState = useCallback(async () => {
    const response = await api.get('/billing/me', { __silent: true })
    const billing = responseData(response)
    queryClient.setQueryData(['billing-me'], billing)
    queryClient.invalidateQueries({ queryKey: ['me', 'billingSummary'] })
    queryClient.invalidateQueries({ queryKey: ['billing-me'] })
    return billing
  }, [])

  const completePayment = useCallback(async (paymentPromise) => {
    setError(null)
    const result = await paymentPromise
    if (result?.redirected) {
      setMessage(COPY.redirected)
      return
    }
    await refreshBillingState()
    if (result?.agreement) setRecurringState((current) => ({ ...(current || {}), agreement: result.agreement }))
    setMessage(result?.agreement?.message || COPY.paymentSuccess)
    setAgreed(false)
  }, [refreshBillingState])

  useEffect(() => {
    let active = true
    async function load() {
      try {
        const config = await getPortOneV2CheckoutConfig()
        let activePlans = FALLBACK_PLANS
        try {
          const plansResponse = await api.get('/billing/plans', { __silent: true })
          const loadedPlans = responseData(plansResponse)
          if (Array.isArray(loadedPlans) && loadedPlans.length > 0) activePlans = loadedPlans
        } catch {
          activePlans = FALLBACK_PLANS
        }
        let recurring = null
        if (config.recurringEnabled) {
          try {
            recurring = await getMyPortOneRecurringAgreement()
          } catch {
            recurring = null
          }
        }
        if (active) {
          setCheckoutConfig(config)
          setPlans(activePlans)
          setRecurringState(recurring)
          setPaymentMode(config.recurringEnabled ? 'RECURRING' : 'ONE_TIME')
        }
      } catch (loadError) {
        if (active) {
          setCheckoutConfig({ enabled: false, ready: false })
          setError(getApiErrorMessage(loadError, COPY.paymentFailed))
        }
      } finally {
        if (active) setLoading(false)
      }
    }
    load()
    return () => {
      active = false
    }
  }, [])

  useEffect(() => {
    if (typeof window === 'undefined') return undefined
    const params = new URLSearchParams(window.location.search)
    const recurringRedirect = isPortOneV2RecurringRedirect(params)
    if (!params.has('paymentId') && !params.has('billingKey') && !params.has('code') && !recurringRedirect) {
      return undefined
    }

    let active = true
    setProcessingPlan('redirect')
    const confirmation = recurringRedirect
      ? confirmPortOneV2RecurringRedirect(params)
      : confirmPortOneV2RedirectPayment(params)
    completePayment(confirmation)
      .catch((paymentError) => {
        if (active) setError(getApiErrorMessage(paymentError, paymentError?.message || COPY.paymentFailed))
      })
      .finally(() => {
        clearPaymentQuery()
        if (active) setProcessingPlan(null)
      })
    return () => {
      active = false
    }
  }, [completePayment])

  const startPayment = async (plan) => {
    if (!agreed) {
      setError(COPY.consentRequired)
      return
    }
    setError(null)
    setMessage(null)
    setProcessingPlan(plan.planCode)
    const suffix = typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
      ? crypto.randomUUID()
      : String(Date.now()) + '-' + Math.random().toString(36).slice(2)
    try {
      const redirectUrl = typeof window === 'undefined'
        ? null
        : window.location.origin + window.location.pathname
      const payment = paymentMode === 'RECURRING'
        ? requestPortOneV2RecurringSubscription({
          planCode: plan.planCode,
          redirectUrl,
        })
        : requestPortOneV2SubscriptionPayment({
          planCode: plan.planCode,
          period: 'MONTH',
          paymentMethod: 'CARD',
          idempotencyKey: 'web-' + plan.planCode.toLowerCase() + '-' + suffix,
          redirectUrl,
        })
      await completePayment(payment)
    } catch (paymentError) {
      setError(getApiErrorMessage(paymentError, paymentError?.message || COPY.paymentFailed))
    } finally {
      setProcessingPlan(null)
    }
  }

  const cancelRecurring = async () => {
    if (typeof window !== 'undefined' && !window.confirm(COPY.cancelConfirm)) return
    setCanceling(true)
    setError(null)
    try {
      const agreement = await cancelMyPortOneRecurringAgreement()
      setRecurringState((current) => ({ ...(current || {}), agreement }))
      await refreshBillingState()
      setMessage(agreement?.message)
    } catch (cancelError) {
      setError(getApiErrorMessage(cancelError, COPY.paymentFailed))
    } finally {
      setCanceling(false)
    }
  }

  return (
    <section className="space-y-6">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div>
          <p className="text-sm font-semibold text-brand-sky">{COPY.eyebrow}</p>
          <h1 className="mt-1 text-2xl font-bold text-slate-950">{COPY.title}</h1>
        </div>
        <Link
          to="/billing"
          className="inline-flex min-h-[2.5rem] items-center justify-center rounded border border-slate-300 bg-white px-3 text-sm font-semibold text-slate-800 transition hover:bg-slate-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-400 focus-visible:ring-offset-2"
        >
          {COPY.back}
        </Link>
      </div>

      {loading ? (
        <div className="flex min-h-[16rem] items-center justify-center text-sm text-slate-600" role="status">
          {COPY.loading}
        </div>
      ) : !checkoutConfig?.ready ? (
        <section
          className="flex min-h-[24rem] flex-col items-center justify-center border-y border-sky-200 bg-white px-6 py-12 text-center"
          aria-labelledby="subscribe-mobile-payment-title"
        >
          <span className="flex h-16 w-16 items-center justify-center rounded-lg bg-sky-50 text-brand-navy ring-1 ring-sky-200">
            <Smartphone className="h-8 w-8" aria-hidden="true" />
          </span>
          <h2 id="subscribe-mobile-payment-title" className="mt-6 text-2xl font-black text-slate-950 sm:text-3xl">
            {COPY.mobileTitle}
          </h2>
          <p className="mt-4 max-w-md text-base leading-7 text-slate-600">{COPY.mobileBody}</p>
        </section>
      ) : (
        <>
          <div className="flex flex-wrap items-end justify-between gap-4 border-b border-slate-200 pb-4">
            <div>
              <h2 className="text-xl font-bold text-slate-950">{COPY.webTitle}</h2>
              <p className="mt-1 text-sm text-slate-600">
                {paymentMode === 'RECURRING' ? COPY.recurringDescription : COPY.oneTimeDescription}
              </p>
            </div>
            <div className="flex flex-wrap justify-end gap-2">
              <div className="inline-flex rounded border border-slate-300 bg-slate-50 p-1" aria-label="\uACB0\uC81C \uBC29\uC2DD">
                <button
                  type="button"
                  disabled={!checkoutConfig?.recurringEnabled}
                  onClick={() => setPaymentMode('RECURRING')}
                  className={'rounded px-3 py-2 text-sm font-semibold ' + (
                    paymentMode === 'RECURRING' ? 'bg-white text-brand-navy shadow-sm' : 'text-slate-500'
                  )}
                >
                  {COPY.recurring}
                </button>
                <button
                  type="button"
                  onClick={() => setPaymentMode('ONE_TIME')}
                  className={'rounded px-3 py-2 text-sm font-semibold ' + (
                    paymentMode === 'ONE_TIME' ? 'bg-white text-brand-navy shadow-sm' : 'text-slate-500'
                  )}
                >
                  {COPY.oneTime}
                </button>
              </div>
            </div>
          </div>

          {recurringState?.agreement ? (
            <section className="flex flex-wrap items-center justify-between gap-4 border-y border-sky-200 bg-sky-50 px-4 py-3">
              <div>
                <p className="text-sm font-bold text-brand-navy">{recurringState.agreement.statusLabel}</p>
                <p className="mt-1 text-sm text-slate-600">{recurringState.agreement.message}</p>
                {recurringState.agreement.nextPaymentAt ? (
                  <p className="mt-1 text-xs font-semibold text-slate-500">
                    {'\uB2E4\uC74C \uACB0\uC81C\uC77C '}{formatDate(recurringState.agreement.nextPaymentAt)}
                  </p>
                ) : null}
              </div>
              {managedRecurring ? (
                <button
                  type="button"
                  onClick={cancelRecurring}
                  disabled={canceling}
                  className="min-h-[2.5rem] rounded border border-slate-300 bg-white px-3 text-sm font-semibold text-slate-800 hover:bg-slate-50 disabled:text-slate-400"
                >
                  {canceling ? COPY.processing : COPY.cancelRecurring}
                </button>
              ) : null}
            </section>
          ) : null}

          <div className="grid gap-4 lg:grid-cols-2">
            {visiblePlans.map((plan) => {
              const enterprise = plan.planCode === 'ENTERPRISE'
              const busy = processingPlan === plan.planCode
              return (
                <article
                  key={plan.planCode}
                  className={'flex min-h-[22rem] flex-col rounded-lg border bg-white p-5 ' + (
                    enterprise ? 'border-sky-400 shadow-sm' : 'border-slate-200'
                  )}
                >
                  <div className="flex items-start justify-between gap-3">
                    <div>
                      <h3 className="text-lg font-black text-slate-950">{plan.planName || plan.planCode}</h3>
                      <p className="mt-2 text-3xl font-black text-slate-950">
                        {'\u20A9'}{formatPrice(plan.price)}
                        <span className="ml-1 text-sm font-medium text-slate-500">/ \uC6D4</span>
                      </p>
                    </div>
                    {enterprise && Number(plan.price) < 39000 ? (
                      <span className="rounded bg-rose-50 px-2 py-1 text-xs font-bold text-rose-700">
                        EARLY BIRD
                      </span>
                    ) : null}
                  </div>

                  {enterprise && Number(plan.price) < 39000 ? (
                    <p className="mt-2 text-sm text-slate-500">
                      <span className="line-through">{'\u20A9'}{formatPrice(39000)}</span>
                      <span className="ml-2 font-semibold text-rose-700">{'\u20A9'}{formatPrice(plan.price)}</span>
                    </p>
                  ) : null}

                  <ul className="mt-5 space-y-3 text-sm text-slate-700">
                    {(PLAN_FEATURES[plan.planCode] || []).map((feature) => (
                      <li key={feature} className="flex gap-2">
                        <Check className="mt-0.5 h-4 w-4 shrink-0 text-emerald-600" aria-hidden="true" />
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>

                  <button
                    type="button"
                    onClick={() => startPayment(plan)}
                    disabled={Boolean(processingPlan) || Boolean(managedRecurring)}
                    className="mt-auto inline-flex min-h-[2.75rem] w-full items-center justify-center gap-2 rounded bg-brand-navy px-4 text-sm font-bold text-white transition hover:bg-sky-900 disabled:cursor-not-allowed disabled:bg-slate-300"
                  >
                    {busy ? <Clock3 className="h-4 w-4" aria-hidden="true" /> : <CreditCard className="h-4 w-4" aria-hidden="true" />}
                    {busy ? COPY.processing : managedRecurring ? COPY.recurringActive : formatPrice(plan.price) + '\uC6D0 ' + (paymentMode === 'RECURRING' ? COPY.startRecurring : COPY.pay)}
                  </button>
                </article>
              )
            })}
          </div>

          <div className="space-y-3 border-t border-slate-200 pt-5">
            <label className="flex cursor-pointer items-start gap-3 text-sm leading-6 text-slate-700">
              <input
                type="checkbox"
                checked={agreed}
                onChange={(event) => setAgreed(event.target.checked)}
                className="mt-1 h-4 w-4 rounded border-slate-300 text-brand-navy focus:ring-sky-400"
              />
              <span>
                {COPY.consentPrefix}
                <Link to="/terms" className="font-semibold text-brand-navy underline">{COPY.terms}</Link>
                {COPY.and}
                <Link to="/refund-policy" className="font-semibold text-brand-navy underline">{COPY.refund}</Link>
                {COPY.consentSuffix}
                {paymentMode === 'RECURRING' ? (
                  <span className="mt-1 block text-xs text-slate-600">{COPY.recurringConsent}</span>
                ) : null}
              </span>
            </label>
            <p className="flex items-center gap-2 text-xs text-slate-500">
              <ShieldCheck className="h-4 w-4" aria-hidden="true" />
              {COPY.secure}
            </p>
          </div>
        </>
      )}

      {message ? (
        <div className="rounded border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm font-semibold text-emerald-800" role="status">
          {message}
        </div>
      ) : null}
      {error ? (
        <div className="rounded border border-rose-200 bg-rose-50 px-4 py-3 text-sm font-semibold text-rose-800" role="alert">
          {error}
        </div>
      ) : null}
    </section>
  )
}
